"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _StyleSheet = _interopRequireDefault(require("../../PlatformStyleSheet/StyleSheet"));

var _AaTextInput = require("./AaTextInput.model");

var _LayoutConstants = require("../../Layout/LayoutConstants");

var _AaIcon = _interopRequireDefault(require("../airasia-icon-component/AaIcon.component"));

var _uiUtils = require("@airasia/ui-utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var AaTextInputComponent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AaTextInputComponent, _React$Component);

  var _super = _createSuper(AaTextInputComponent);

  function AaTextInputComponent(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, AaTextInputComponent);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleFocus", function () {
      if (!_this.state.isFieldActive) {
        _this.setState({
          isFieldActive: true
        });

        _this.props.controls.onInputFocus(true);

        _this.setState({
          inputFocus: true
        });

        _reactNativeWeb.Animated.timing(_this.position, {
          toValue: 1,
          duration: 150
        }).start();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleBlur", function () {
      //TODO - not getting updated props value
      if (_this.state.isFieldActive && !_this.props.controls.value) {
        _this.setState({
          isFieldActive: false,
          inputFocus: false
        });

        _this.props.controls.onInputFocus(false);

        _reactNativeWeb.Animated.timing(_this.position, {
          toValue: 0,
          duration: 150
        }).start();
      } else {
        _this.setState({
          isFieldActive: false,
          inputFocus: false
        });

        _this.props.controls.onInputFocus(false);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeText", function (updatedValue) {
      _this.setState({
        updatedValue: updatedValue
      });

      var _this$props$controls = _this.props.controls,
          attrName = _this$props$controls.attrName,
          updateMasterState = _this$props$controls.updateMasterState;
      updateMasterState(attrName, updatedValue);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "returnAnimatedTitleStyles", function () {
      var isFieldActive = _this.state.isFieldActive;
      var _this$props$controls2 = _this.props.controls,
          titleActiveColor = _this$props$controls2.titleActiveColor,
          titleInactiveColor = _this$props$controls2.titleInactiveColor,
          titleActiveSize = _this$props$controls2.titleActiveSize,
          titleInActiveSize = _this$props$controls2.titleInActiveSize;
      var x = {
        top: _this.position.interpolate({
          inputRange: [0, 1],
          outputRange: [16, 6]
        }),
        fontSize: isFieldActive ? titleActiveSize : titleInActiveSize,
        color: isFieldActive ? titleActiveColor : titleInactiveColor,
        fontFamily: _reactNativeWeb.Platform.OS !== 'web' ? _uiUtils.DefaultTokens.FONT_REGULAR : _uiUtils.DefaultTokens.FONT_WEB
      };

      if (_this.props.controls.attrName == 'destination') {
        if (_this.state.inputFocus) {
          x['left'] = 15;
        } else {
          // if(this.props.controls.value){
          x['left'] = 30; // }
          // else{
          //     x['left']=15
          // }
        }
      }

      return x;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "placeholderText", function () {
      if (_this.props.controls.isFloatingLabelRequired) {
        if (_this.state.isFieldActive) return _this.props.translation.placeholder;
      } else {
        return _this.props.translation.placeholder;
      }
    });

    var _ref = _this.props.controls ? _this.props.controls : null,
        value = _ref.value;

    _this.position = new _reactNativeWeb.Animated.Value(value ? 1 : 0);
    _this.state = {
      isFieldActive: false,
      updatedValue: ''
    };
    return _this;
  }

  (0, _createClass2["default"])(AaTextInputComponent, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.controls.value !== this.props.controls.value) {
        if (this.props.controls.value && this.props.controls.value.length > 0) {
          _reactNativeWeb.Animated.timing(this.position, {
            toValue: 1,
            duration: 150
          }).start();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var isFloatingLabelRequired = this.props.controls.isFloatingLabelRequired;
      var textInputAlign = isFloatingLabelRequired ? styles.textAlignMarginTop : styles.textAlignCenter; // let mobileGap = Dimensions.get('window').width<=695?15:0;

      return /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
        style: [styles.container, this.props.controls.focusTextInput || this.state.inputFocus ? styles.blueFocusWrapper : this.props.controls.invalidInput && styles.invalidInputContainer, this.props.controls.textInputContainerStyle, !isFloatingLabelRequired && textInputAlign]
      }, isFloatingLabelRequired ? /*#__PURE__*/React.createElement(_reactNativeWeb.Animated.Text, {
        style: [styles.titleStyles, this.returnAnimatedTitleStyles(), {
          color: '#75767A'
        }]
      }, this.props.translation.title) : null, /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
        style: [!isFloatingLabelRequired && textInputAlign, styles.fullParentHeight]
      }, /*#__PURE__*/React.createElement(_reactNativeWeb.TextInput, (0, _extends2["default"])({
        value: this.props.controls.value || '',
        placeholder: this.placeholderText(),
        placeholderTextColor: "#5c5f63",
        style: [styles.textInput, isFloatingLabelRequired && textInputAlign, styles.overallStyle, this.props.controls.textInputStyles, !this.state.inputFocus && this.props.controls.attrName == 'destination' ? {
          paddingLeft: 30
        } : {}],
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onChangeText: this.onChangeText,
        keyboardType: "default",
        ref: this.props.controls.inputReference,
        selectTextOnFocus: this.props.controls.selectTextOnFocus,
        clearButtonMode: this.props.controls.clearButtonMode
      }, this.props.controls.otherTextInputProps)), this.props.controls.inputContainerIconName && /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
        style: styles.textInputIcon
      }, /*#__PURE__*/React.createElement(_AaIcon["default"], {
        controls: {
          iconName: this.props.controls.inputContainerIconName,
          iconStyle: {
            height: 24,
            width: 24
          },
          onPress: this.props.controls.onInputFocus,
          accessible: this.props.controls.inputContainerIconAccessibility
        }
      }))));
    }
  }]);
  return AaTextInputComponent;
}(React.Component);

(0, _defineProperty2["default"])(AaTextInputComponent, "defaultProps", {
  keyboardType: 'default',
  titleActiveSize: 12,
  titleInActiveSize: 16,
  titleActiveColor: '#5C5F63',
  titleInactiveColor: '#75767A',
  textInputStyles: {},
  inputFocus: false,
  otherTextInputAttributes: {},
  clearButtonMode: 'always'
});

var styles = _StyleSheet["default"].create({
  overallStyle: {
    color: '#1d1d1d',
    fontSize: 14,
    fontFamily: _uiUtils.DefaultTokens.FONT_MEDIUM,
    web: {
      fontWeight: '500',
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB
    }
  },
  container: {
    backgroundColor: '#fff',
    zIndex: 3,
    borderRadius: 3,
    borderStyle: 'solid',
    borderWidth: 0.5,
    height: 56,
    borderColor: "#d9dbe0"
  },
  textAlignCenter: {
    justifyContent: 'center'
  },
  textAlignMarginTop: {
    marginTop: 22
  },
  blueFocusWrapper: {
    web: {
      borderRadius: 3,
      borderStyle: 'solid',
      borderWidth: 1,
      height: 56,
      borderColor: "#4b4fa6",
      position: 'relative',
      bottom: '0'
    }
  },
  invalidInputContainer: {
    borderRadius: 3,
    borderStyle: 'solid',
    borderWidth: 0.5,
    borderColor: "#e10000"
  },
  textInput: {
    fontSize: 14,
    position: 'relative',
    paddingHorizontal: 15,
    web: {
      overflowY: "hidden",
      outlineStyle: 'none'
    }
  },
  titleStyles: {
    position: 'absolute',
    left: 15
  },
  fullParentHeight: {
    web: {
      width: null,
      height: null,
      flex: 1,
      overflowX: 'hidden'
    }
  },
  textInputIcon: {
    position: 'absolute',
    right: 0,
    top: 15
  }
});

var _default = AaTextInputComponent;
exports["default"] = _default;